export default "__VITE_ASSET__08e6569d__"